module.exports = __webpack_public_path__ + "static/media/insights.3386f399.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/UpZone/insights.png
// module id = 214
// module chunks = 0